<app-bread-crump [title]="('Nav.libraries' | translate)" [description]="('breadcrumps.bibliosDescription' | translate)"
  [items]="[
    { label:('Nav.Home' | translate), url: '/home' },
    { label:('Nav.libraries' | translate) }
  ]">
</app-bread-crump>

<section class="container d-flex flex-column my-5" style="max-width: 1280px">

  @if (loading()) {
  <div class="text-center my-5">
    <span>{{ 'COMMON.loading' | translate }}</span>
  </div>
  } @else {
  <div class="global-cards-row" style="margin-block: 40px;">

    @for (library of libraries; track library.id) {
    <div class="global-cards-row__container">
      <app-libraries-card [library]="library" />
    </div>
    }
  </div>

  @if (libraries.length === 0) {
  <div class="text-center my-5">
    <p>لا توجد مكتبات.</p>
  </div>
  }

  @if (pagination.totalPages > 1) {
  <div class="mt-4">
    <app-browse-paginator [pagination]="pagination" (pageChange)="onPageChange($event)">
    </app-browse-paginator>
  </div>
  }
  }
</section>

<!-- Starts : Footer -->
<app-footer></app-footer>
<!-- Ends : Footer -->